module.exports = __webpack_public_path__ + "img/banner01.634ca31f.jpg";